import { ActionType } from "./Actions";
import configurationReducer from "./Reducers/Kiosk/configurationReducer";
import chatbotReducer from "./Reducers/Kiosk/chatbotReducer";
// import userReducer from './Reducers/Kiosk/userReducer';
import agentReducer from "./Reducers/Kiosk/agentReducer";
import fontSizeReducer from "./Reducers/Kiosk/fontSizeReducer";
import veilleReducer from "./Reducers/Kiosk/veilleReducer";
import settingsReducer from "./Reducers/Kiosk/settingsReducer";
import viewsConfigurationReducer from "./Reducers/Kiosk/viewsConfigurationReducer";
import printerReducer from "./Reducers/Kiosk/printerReducer";
import {
  Configuration,
  ViewsConfiguration,
  ChatbotData,
} from "../model/Configuration";
import {
  defaultConfiguration,
  defaultViewsConfiguration,
} from "../model/DefaultConfiguration";
import { User } from "../model/User";
import { Agent } from "../model/Agent";
import { FontSize } from "../model/FontSize";
import { Veille } from "../model/Veille";
import { CustomVoice } from "@davi-ai/retorik-framework";
import voiceReducer from "./Reducers/Kiosk/voiceReducer";
import defaultModeReducer from "./Reducers/Kiosk/defaultModeReducer";

const combineReducers =
  (slices: any) => (state: KioskStateType, action: ActionType) =>
    Object.keys(slices).reduce(
      // use for..in loop, if you prefer it
      (acc, prop) => ({
        ...acc,
        // @ts-ignore
        ...slices[prop](acc, action), // acc[prop], action),
      }),
      state
    );

export type KioskStateType = {
  configuration: Configuration;
  viewsConfiguration: ViewsConfiguration;
  chatbot: ChatbotData | undefined;
  user: User;
  agent: Agent;
  fontsize: FontSize;
  veille: Veille;
  settingsOpened: boolean;
  voice: CustomVoice | undefined;
  defaultMode: number | undefined;
  printer: string | null;
};

export const InitialState: KioskStateType = {
  configuration: { ...defaultConfiguration },
  viewsConfiguration: { ...defaultViewsConfiguration },
  chatbot: undefined,
  user: null,
  agent: null,
  fontsize: null,
  veille: null,
  settingsOpened: false,
  voice: undefined,
  defaultMode: undefined,
  printer: null,
};

export const Reducer = combineReducers({
  configurationReducer,
  chatbotReducer,
  viewsConfigurationReducer,
  // userReducer,
  agentReducer,
  fontSizeReducer,
  veilleReducer,
  settingsReducer,
  voiceReducer,
  defaultModeReducer,
  printerReducer,
});
